import { toJS } from 'mobx'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { omit } from 'util/object'
import { ym } from 'util/ym'

function fix(message: any) {
  try {
    if (!message || typeof message !== 'object') return message
    message = toJS(message)
    if (Array.isArray(message)) return message
    for (let [key, value] of Object.entries(message)) {
      message[key] = fix(value)
    }
    return message
  } catch (e) {
    return message
  }
}

export function postMessage(name: string, message?: unknown): void {
  message = fix(message)
  parent.postMessage({ source: 'showoff-try-on', name, message }, '*')
}

export function postMessageSelf(name: string, message?: unknown): void {
  window.postMessage({ source: 'showoff-try-on-client', name, message }, '*')
}

export function addMessageListener<M = any>(name: string, listener: (message: M) => void): () => void {
  const _listener = (event: any) => {
    const { data } = event
    if (data.source === 'showoff-try-on-client' && data.name === name) {
      listener(data.message)
    }
  }
  window.addEventListener('message', _listener)
  return () => window.removeEventListener('message', _listener)
}

type OnEventName = `on-${string}`

const INTERNAL = ['on-update', 'on-state']
const SKIP_YM = ['on-open-widget', 'on-close-widget']

export function sendEvent(name: OnEventName, event: Record<string, unknown>) {
  const now = new Date().toISOString()
  const common = {
    time: now,
    user_id: me.user_id,
    external_user_id: me.external_user,
    company_id: opt.company,
    product_id: opt.product,
  }
  const message = omit({ ...common, ...event })
  postMessage(name, message)

  const old = INTERNAL.includes(name)
  if (old) return

  window.ReactNativeWebView?.postMessage(JSON.stringify({ name, message }))

  if (!SKIP_YM.includes(name)) ym(name, message)
}
